import { Location } from 'history'
import { withRouter } from 'react-router'
import React, { Fragment, ReactNode, useEffect } from 'react'

// https://reacttraining.com/react-router/web/guides/scroll-restoration
const _ScrollToTopOnRouteChange = ({
  children,
  location: { pathname },
}: {
  children?: ReactNode
  location: Location
}) => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return <Fragment>{children}</Fragment>
}

export const ScrollToTopOnRouteChange = withRouter(_ScrollToTopOnRouteChange)
